// Wrap all the possible locations a "type" could be hiding
// 1/26/2021 - this is primarily to handle old notifications 
// coming in as the notificaiton update is rolling out
export function getNotificationType(messageData) {
    if (messageData === undefined || messageData.payload === undefined) return '';

    let payload: any = {};

    try {
        payload = JSON.parse(messageData.payload);
    }
    catch(e) {
        payload = messageData.payload;
    }

    if (payload.type !== undefined) {
        return payload.type;
    }
    else {
        try {
            const subPayload = JSON.parse(payload.data);

            return subPayload.type;
        }
        catch(e) {
            if (payload.data === undefined) {
                return '';
            }
            else {
                return payload.data.type;
            }
        }
    }
}

function checkSubPayload(data) {
    try {
        data.payload = JSON.parse(data.payload);
        return data;
    }
    catch(e) {
        return data;
    }
}

export function getNotificationPayload(messageData) {
    if (messageData === undefined) return {}

    try {
        return checkSubPayload(JSON.parse(messageData.payload));
    }
    catch(e) {
        if (messageData.payload === undefined) return {}

        return checkSubPayload(messageData.payload);
    }
}

export function getNotificationPayloadData(type: string, data: any) {
    const _payloadData = data;

    if (type === 'bmc-comment') {
        return (_payloadData && _payloadData.data) ? _payloadData.data : {};
    }

    if (type === 'export') {
        return _payloadData;
    }

    if (type === 'insight') {
        try {
            const d = JSON.parse(_payloadData.data);
            return d;
        }
        catch(e) {
            // let it fall through
        }
    }

    return _payloadData;
}
